const cabinLimit = 9;
const cabinLimitForP2P = 4;

export const isOverCabinLimit = (amountOfCabins: number, isP2P: boolean) =>
  isP2P ? amountOfCabins >= cabinLimitForP2P : amountOfCabins >= cabinLimit;
